import { useState } from 'react'
import './LandingView.css'
import logo from '../../assets/logo.svg'
import star from '../../assets/star.svg'
import SVG from 'react-inlinesvg'
import badge from '../../assets/badge.svg'

interface LandingViewProps {
  startCallback: () => void
}

/*
  reference
  <h2 className='font-medium'>
    <span className="text-[43px] leading-[50px]">HOSPITAL</span>
    <br />
    <span className="text-[53px] leading-[50px]">MYSTERIES</span>
  </h2>

  public\images\whatdunnit_logo.svg
*/

export default function LandingView (props: LandingViewProps) {
  const [animationClass, setAnimationClass] = useState('animation-fadeIn')

  function startClicked () {
    setAnimationClass('animation-leave')
    props.startCallback()
  }

  return (
    <div className='w-full flex-center flex-col h-body'>
      <div className={`w-[300px] mx-auto text-white text-center font-museo-round ${animationClass}`}>
        <div className={'object-contain mx-auto w-full xs:w-10/12 short:w-10/12'}>
          <div className={'max-w-[540px] mx-auto'}>
            <SVG src={logo} />
          </div>

          <div className={'max-w-[502px] mx-auto mt-[46px]'}>
            <SVG src={star} />
          </div>
        </div>

        <div className='object-contain mx-auto my-[30px] w-full xs:hidden short:w-10/12'>
          <div className={'max-w-[524px] mx-auto'}>
            <SVG src={badge} />
          </div>
        </div>

        <button className='btn--blue xs:mt-[30px] short:mw-160 short:mh-40' onClick={startClicked}>START</button>
      </div>

      <p
        className={`text-sm text-primary-blue whitespace-nowrap xs:whitespace-normal xs:p-3 text-center ${animationClass}`}>
        This is a POC and should only be used on Chrome
      </p>
    </div>
  )
}
